module.exports = __webpack_public_path__ + "img/icon02.045340f2.svg";